import { useState } from "react";
import { ChevronDown, ChevronUp, Info } from "lucide-react";

export function ModuleDescription({ title, children }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`rounded-lg border transition-colors ${open ? "bg-blue-50/50 border-blue-200" : "bg-muted/30 border-transparent hover:border-blue-100"}`}
      data-testid="module-description"
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-2 px-4 py-2 text-left text-sm"
      >
        <Info className="w-4 h-4 text-blue-500 shrink-0" />
        <span className="font-medium text-blue-700">{title || "Jak to dziala?"}</span>
        {open ? <ChevronUp className="w-4 h-4 ml-auto text-blue-400" /> : <ChevronDown className="w-4 h-4 ml-auto text-blue-400" />}
      </button>
      {open && (
        <div className="px-4 pb-3 text-xs text-muted-foreground leading-relaxed space-y-1.5">
          {children}
        </div>
      )}
    </div>
  );
}
